// extracted by mini-css-extract-plugin
module.exports = {"image":"ImagesGridUI__image___ZcjoF","overlay":"ImagesGridUI__overlay___1PLDg","zoom-overlay":"ImagesGridUI__zoom-overlay___1jOxB"};